module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bSeiIB/tc-custom/9781468301601.jpg?1695312871121",
      "alt": "This image is the cover for the book Haiti"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haiti\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Written by a journalist and family insider, “the most intimate and revealing examination to date” of the Duvaliers and their Haitian legacy.")]), _vm._v(" ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(")"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Recounts the depredations and corruption of the Duvalier regime in Haiti, from the election of Papa Duvalier in 1957 to the exile of his son, Jean Claude. Written by the senior editor of the Haiti Times and the sister-in-law of Baby Doc’s successor, this account details the excesses of the dictatorship and the grim state in which the Duvaliers left the country when the regime was finally overthrown."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “History with a human face, effective, moving, written with surprising and admirable restraint.” —"), _c('i', [_vm._v("Kirkus Reviews")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Abbott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elizabeth Abbott is Research Associate at Trinity College, University of Toronto, and, from 1991 to 2004, was Dean of Women. She is the author of several books, including Sugar and Haiti. She lives in Toronto.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The Overlook Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0